import { isMobile } from '../constants/devices.constants';
import { createSrcset, getElementOrParentByClassName } from '../helpers/utils';
import { reportEngagement } from './personalization.service';
const CHAT_BEHAVIOR = "chat";
const LINK_BEHAVIOR = "link";
const MARKETING_SIGN_UP_BEHAVIOR = "marketingSignUp";
const NO_BEHAVIOR = "none"; // eslint-disable-line @typescript-eslint/no-unused-vars
/**
 *
 * @param {*} config
 * @param {*} overrides
 * @returns
 * @deprecated build components with media-content.liquid instead
 */
export function generateMediaElement(config, overrides) {
    if (!overrides) {
        overrides = {};
    }
    let mediaEl;
    // TODO: revist when video is prioritized
    if (config.mediaType === "video") {
        const source = document.createElement("source");
        source.type = "video/webm";
        source.src = config.videoUrl;
        mediaEl = document.createElement("video");
        mediaEl.autoplay = true;
        mediaEl.muted = true;
        mediaEl.loop = true;
        mediaEl.append(source);
    }
    else if (config.mediaType === "backgroundColor") {
        mediaEl = document.createElement('div');
        mediaEl.style.backgroundColor = config.backgroundColor.value;
    }
    else {
        let desktopSource;
        if (config.desktopImage) {
            desktopSource = document.createElement("source");
            desktopSource.media = "(min-width: 1024px)";
            desktopSource.dataset.srcset = createSrcset(config.desktopImage.shopifyUrl, [1024, 1280, 1440]);
            desktopSource.dataset.sizes = "(max-width: 1440px) 100vw, 1440px";
            desktopSource.width = config.desktopImage.width;
            desktopSource.height = config.desktopImage.height;
        }
        const defaultImg = document.createElement("img");
        defaultImg.classList.add('media-content__image');
        const imgConfig = config.mobileImage || config.image;
        defaultImg.alt = imgConfig.altText;
        defaultImg.dataset.srcset = createSrcset(imgConfig.shopifyUrl, overrides.imageSrcset || [375, 390, 414, 428, 768, 800]);
        defaultImg.dataset.sizes = overrides.sizes || "100vw";
        defaultImg.width = imgConfig.width;
        defaultImg.height = imgConfig.height;
        mediaEl = document.createElement("picture");
        if (desktopSource) {
            mediaEl.append(desktopSource);
        }
        mediaEl.append(defaultImg);
    }
    mediaEl.classList.add("media-content__media");
    const title = document.createElement("h2");
    title.classList.add('media-content__title', `media-content__title--${config._type}`);
    if (!config.copyInsideImage) {
        title.classList.add('default');
    }
    if (config.hideHeading) {
        title.classList.add("hidden");
    }
    title.textContent = config.heading;
    // subcopy
    const subcopy = document.createElement("p");
    subcopy.classList.add('media-content__subcopy');
    if (!config.subheading) {
        subcopy.classList.add('hidden');
    }
    subcopy.textContent = config.subheading;
    // cta
    let urlEl;
    let cta;
    if ([LINK_BEHAVIOR, CHAT_BEHAVIOR, MARKETING_SIGN_UP_BEHAVIOR].includes(config.behavior) || config.url) {
        urlEl = document.createElement('a');
        urlEl.classList.add("media-content__url-container");
        urlEl.href = config.url || "#";
        urlEl.append(mediaEl);
        cta = document.createElement("a");
        cta.classList.add("media-content__cta");
        cta.textContent = config.ctaText;
        cta.href = config.url || "#";
        if (config.ctaStyling) {
            cta.classList.add("button-v2", `${config.ctaStyling}`);
        }
        if (config.behavior === CHAT_BEHAVIOR) {
            urlEl.classList.add("open_chat");
            cta.classList.add("open_chat");
        }
        else if (config.behavior === MARKETING_SIGN_UP_BEHAVIOR) {
            urlEl.classList.add("js-marketing-opt-in");
            cta.classList.add("js-marketing-opt-in");
        }
    }
    // description container
    const innerContainer = document.createElement("div");
    innerContainer.classList.add('media-content__description-inner-container');
    const descriptionContainer = document.createElement("div");
    descriptionContainer.classList.add('media-content__description', "js-media-content-description");
    descriptionContainer.append(innerContainer);
    if (config.fontColor) {
        title.style.color = config.fontColor.value;
        subcopy.style.color = config.fontColor.value;
    }
    innerContainer.append(title, subcopy);
    if (cta) {
        innerContainer.append(cta);
    }
    if (config.centerText || overrides.centerText) {
        descriptionContainer.style.textAlign = "center";
    }
    // container
    const container = document.createElement("div");
    container.id = `editorial-${config._id}`;
    container.classList.add('media-content__container', `media-content__container--${config._type}`);
    if (config.decisionId) {
        container.dataset.decisionId = config.decisionId;
    }
    // text placement (inside or outside image)
    if (config.copyInsideImage) {
        container.classList.add('media-content__container--copy-inside', "max-1440");
        let isMobileView = isMobile();
        window.addEventListener("resize", () => {
            if (isMobileView !== isMobile()) {
                isMobileView = isMobile();
                updateInnerTextConfig(descriptionContainer, config, isMobileView ? "mobile" : "desktop");
            }
        });
        updateInnerTextConfig(descriptionContainer, config, isMobileView ? "mobile" : "desktop");
        const containerEl = urlEl || mediaEl;
        containerEl.append(descriptionContainer);
        container.append(containerEl);
    }
    else {
        container.classList.add("media-content__container--copy-outside");
        container.append(urlEl || mediaEl, descriptionContainer);
    }
    return container;
}
export function initMediaContentListeners() {
    document.addEventListener('click', (e) => {
        const target = e.target;
        const editorialContentEl = getElementOrParentByClassName(target, 'editorial-content') || getElementOrParentByClassName(target, "media-content__container--editorial-card");
        if (editorialContentEl) {
            if (editorialContentEl.dataset.decisionId) {
                reportEngagement([{
                        type: "CLICK",
                        decisionId: editorialContentEl.dataset.decisionId
                    }]);
            }
        }
    });
}
/**
 * @deprecated Copy-inside positioning is server-rendered via media-content.liquid and
 * components/_media-content.scss. Retained for generateMediaElement() until that path
 * is removed.
 */
function updateInnerTextConfig(descriptionContainer, config, device) {
    const EM_SIZE = 16;
    // used to calculate difference between figma file width and browser textbox width
    const EXTRA_BROWSER_SPACE_RATIO = 0.02;
    const innerTextConfig = config.innerTextConfig || config[`${device}InnerTextConfig`];
    const innerContainer = descriptionContainer.querySelector('.media-content__description-inner-container');
    if (innerTextConfig) {
        if (innerContainer) {
            innerContainer.style.width = innerTextConfig.width ? `${(innerTextConfig.width + (innerTextConfig.width * EXTRA_BROWSER_SPACE_RATIO)) / EM_SIZE}em` : '';
            if (innerTextConfig.positions?.length) {
                innerContainer.style.position = 'absolute';
                ["top", "bottom", "left", "right"].forEach((p) => {
                    innerContainer.style[p] = '';
                });
                innerTextConfig.positions.forEach((p) => {
                    innerContainer.style[p.property] = `${p.length / EM_SIZE}em`;
                });
            }
            else {
                innerContainer.style.position = 'static';
            }
        }
        // TODO: innerTextConfig.centerVertically and innerTextConfig.centerHorizontally are deprecated; use innerTextConfig.verticalPosition and innerTextConfig.horizontalPosition instead
        descriptionContainer.style.alignItems = innerTextConfig.verticalPosition ? innerTextConfig.verticalPosition : innerTextConfig.centerVertically ? "center" : "";
        descriptionContainer.style.justifyContent = innerTextConfig.horizontalPosition ? innerTextConfig.horizontalPosition : innerTextConfig.centerHorizontally ? "center" : "";
        descriptionContainer.style.padding = innerTextConfig.padding || '';
    }
    const title = descriptionContainer.querySelector('.media-content__title');
    if (title) {
        const existingHeadingStyle = Array.from(title.classList.values()).find(c => c.includes('fluid'));
        if (existingHeadingStyle) {
            title.classList.remove(existingHeadingStyle);
        }
        title.classList.add(`fluid-${(config.headingStyling || config[`${device}HeadingStyling`])}`);
    }
    const subcopy = descriptionContainer.querySelector('.media-content__subcopy');
    if (subcopy && isMobile() && config.hideSubheadingMobile) {
        subcopy.style.display = "none";
    }
    else {
        subcopy.style.display = "block";
    }
}
